import { startGuest, getToken, isGuest } from "../src/lib/client/api.js";
import { t } from "../src/lib/client/i18n.js";

<script>
  if (typeof window !== "undefined") {
    if (getToken() || isGuest()) {
      window.location.replace("/app");
    }
  }
</script>

<div class="landing">
  <div class="landing__glow" aria-hidden="true"/>
  <main class="landing__main">
    <div class="landing__brand">
      <img
        class="landing__logo"
        src="/assets/tiles/modern/logo.svg"
        alt=""
        width="112"
        height="112"
      >
      <h1 class="landing__title">${t("brand.name")}</h1>
      <p class="landing__tagline">${t("brand.tagline")}</p>
    </div>

    <p class="landing__lede">${t("landing.lede")}</p>
    <ul class="landing__points">
      <li>${t("landing.point1")}</li>
      <li>${t("landing.point2")}</li>
      <li>${t("landing.point3")}</li>
    </ul>

    <div class="landing__actions">
      <a class="btn btn--primary landing__cta" href="/login?view=signup">
        ${t("landing.createAccount")}
      </a>
      <button
        type="button"
        class="btn btn--ghost landing__cta"
        onClick() {
          startGuest();
          window.location.href = "/app";
        }
      >
        ${t("landing.tryGuest")}
      </button>
    </div>
    <p class="landing__guest-note">${t("landing.guestNote")}</p>

    <p class="landing__signin">
      ${t("landing.haveAccount")} <a href="/login">${t("landing.signIn")}</a>
    </p>
  </main>
</div>
